import api from '../../../app/api';
import deleteWebsite from './delete-website';
import getAllWithJoin from './get-websites-with-join';
import getAll from './get-websites';
import addWebsite from './add-website';
import editWebsite from './edit-website';
import getWebsite from './get-website';

export const websitesApi = api.injectEndpoints({
    endpoints: (build) => ({
        getWebsites: getAll(build),
        getWebsitesWithJoin: getAllWithJoin(build),
        deleteWebsite: deleteWebsite(build),
        addWebsite: addWebsite(build),
        editWebsite: editWebsite(build),
        getWebsite: getWebsite(build),
    }),
});

export const {
    useGetWebsitesQuery,
    useGetWebsitesWithJoinQuery,
    useDeleteWebsiteMutation,
    useAddWebsiteMutation,
    useEditWebsiteMutation,
    useGetWebsiteQuery,
    useLazyGetWebsitesQuery,
} = websitesApi;
